// @ts-nocheck



import React from 'react';
import isPropValid from '@emotion/is-prop-valid';
import { StyleSheetManager } from 'styled-components';





const shouldForwardProp = (propName, target) =>
typeof target === 'string' ? isPropValid(propName) : true;

const StyledComponentsCompatibility = ({ children }) =>
<StyleSheetManager shouldForwardProp={shouldForwardProp}>
    {children}
  </StyleSheetManager>;


export default StyledComponentsCompatibility;
